import { LitElement, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { appState, type AppStateData } from '../store/AppState';

const ONBOARDING_KEY = 'coach-onboarding-dismissed';

@customElement('coach-onboarding')
export class CoachOnboarding extends LitElement {
  createRenderRoot() {
    return this;
  }

  @state()
  private visible = false;

  @state()
  private teamName = '';

  private unsubscribe: (() => void) | null = null;

  connectedCallback() {
    super.connectedCallback();
    this.unsubscribe = appState.subscribe((state: AppStateData) => {
      this.checkOnboarding(state);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.unsubscribe?.();
  }

  private checkOnboarding(state: AppStateData) {
    const user = state.auth.user;
    if (!user || user.is_admin) {
      this.visible = false;
      return;
    }

    const teams = user.teams;
    if (!teams || teams.length === 0) {
      this.visible = false;
      return;
    }

    // Check if already dismissed for this user
    const dismissedKey = `${ONBOARDING_KEY}-${user.id}`;
    if (localStorage.getItem(dismissedKey)) {
      this.visible = false;
      return;
    }

    this.teamName = teams.length === 1
      ? teams[0].team_name ?? 'your team'
      : `${teams.length} teams`;
    this.visible = true;
  }

  private handleDismiss() {
    const user = appState.user;
    if (user) {
      localStorage.setItem(`${ONBOARDING_KEY}-${user.id}`, 'true');
    }
    this.visible = false;
  }

  render() {
    if (!this.visible) return nothing;

    return html`
      <dialog class="modal modal-open">
        <div class="modal-box">
          <h3 class="font-bold text-lg">Welcome to Pitch Counter!</h3>
          <p class="py-4 text-base-content/80">
            You've been added to <strong>${this.teamName}</strong>.
            You can now create games and track pitches for your team.
          </p>
          <ul class="list-disc list-inside text-sm text-base-content/70 space-y-1 mb-4">
            <li>Create games from the Count tab</li>
            <li>Track pitches for your players in real time</li>
            <li>View stats and history in the Stats tab</li>
          </ul>
          <div class="modal-action">
            <button class="btn btn-primary" @click=${this.handleDismiss}>
              Got it!
            </button>
          </div>
        </div>
        <form method="dialog" class="modal-backdrop">
          <button @click=${this.handleDismiss}>close</button>
        </form>
      </dialog>
    `;
  }
}
